import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'trust-commerce-callback',
    template: ``,
    imports: [SharedModule]
})
export class TrustCommerceCallbackComponent implements OnInit {
    constructor(public route : ActivatedRoute) {}

    ngOnInit() {
        const routeQueryParams = this.route.snapshot.queryParams;
        window.parent.postMessage({'messageType': 'trustCommerceCallback', 'queryParams': routeQueryParams}, '*');
    }
}
